import React from 'react';
import "./index.scss";

import {
	INewsType,
	INewsDescriptionType
} from "@/types/NewsTypes";

interface IProps {
	news: INewsType;
	toggleInfoNews: (e: any) => void;
}

export default class PopupInfoNews extends React.Component<IProps> {
	tempDataPage = "http://localhost/seamlessTempData/tempdata.php";
	tempDataDir = "http://localhost/seamlessTempData/";

	state = {
		active_type: "",
		active_content_idx: 0,
	};

	componentDidMount() {
		const news = this.props.news;
		const newsKeys = Object.keys(this.props.news);

		const emptyNewGame = !news["new-games"] || news["new-games"].length === 0;
		const emptyNewFeatures = !news["new-features"] || news["new-features"].length === 0;

		if (newsKeys.length > 0) {
			if (emptyNewGame && emptyNewFeatures)
				return;
			else if (emptyNewGame)
				this.setState({ active_type: newsKeys[1] });
			else this.setState({ active_type: newsKeys[0] });
		}
	}

	handleOnClickTopic(event: any) {
		const dataPropsTypeNews = event.target.getAttribute('newstype');
		const dataPropsIndex = event.target.getAttribute('index');

		this.setState({
			active_type: dataPropsTypeNews,
			active_content_idx: Number(dataPropsIndex),
		});
	}

	render() {
		const news = this.props.news;
		const emptyNewGame = !news["new-games"] || news["new-games"].length === 0;
		const emptyNewFeatures = !news["new-features"] || news["new-features"].length === 0;

		const categories = { "new-games": "New Games", "new-features": "New Features" };

		//console.log("PIN at aci", this.state.active_type, this.state.active_content_idx)

		return (
			<div className="popup-news">
				<div key="PTH_header" className="popup-header">
					<span>News</span>
					<i className={"sl-ic-close close"} onClick={this.props.toggleInfoNews} />
				</div>

				{ /* Left pane */}
				<div className="topic">
					{
						//Object.keys(news).map((newsType, index_newsType) =>
						Object.keys(categories).map((newsType: string) =>
							<div key={"newstype_" + newsType}>
								<div>
									{ categories[newsType] }
								</div>

								{
									news[newsType] ?
									news[newsType].map((item: INewsDescriptionType, index: number) =>
											<div className={
													this.state.active_type === newsType &&
													this.state.active_content_idx === index ?
													"active" : ""}
												{...{
													index: index,
													newstype: newsType
												}}
												key={"news_" + index + "_" + item.description}
												onClick={this.handleOnClickTopic.bind(this)}
											>
												{item.description}
											</div>
										) : null
								}
							</div>
						)
					}
				</div>

				{ /* News Content */}
				<div className="content">
					{
						(emptyNewGame && emptyNewFeatures) ? (
							<section className="active">
								There are no new games nor features right now.
							</section>
						) : null
					}

					{
						news[this.state.active_type] &&
							news[this.state.active_type][this.state.active_content_idx] ?
							<section className="active"
								dangerouslySetInnerHTML={{ __html: news[this.state.active_type][this.state.active_content_idx].content }}>
							</section> : null
					}
				</div>
			</div>
		);
	}
}